import { DeviceTesterLocale, LowBandWidthLocales, SessionReplacementLocales, TeacherClassError } from "@/locales/localeid";
import { notification } from "ant-design-vue";
import { fmtMsg } from "vue-glcommonui";
import { h } from "vue";
import { SHOW_LOW_BANDWIDTH_NOTIFICATION_DURATION } from "@/store/room/interface";

export const notifySameUserJoined = () => {
  notification.destroy();
  notification.info({
    message: fmtMsg(SessionReplacementLocales.NotificationOldTeacherDesc),
  });
};

export const notifyConnectAgoraServerFailed = () => {
  notification.error({
    message: fmtMsg(TeacherClassError.ConnectAgoraServersErrorTitle),
    description: fmtMsg(TeacherClassError.ConnectAgoraServersError),
    duration: 4,
  });
};
export const notifyStudentJoinedOnDifferentDevice = (callback: () => void) => {
  notification.warn({
    message: fmtMsg(DeviceTesterLocale.StudentAlreadyInClass),
    onClose: callback,
  });
};

export const notifyStudentMovedAppToBackground = (studentName: string) => {
  notification.warning({
    message: h(
      "div",
      {
        style: "font-weight: 500",
      },
      `⚠️ ${fmtMsg(LowBandWidthLocales.RemoteStudentLowBandwidthTitle)}`,
    ),
    description: h("div", [
      h("div", { style: "line-height: 1.5;" }, [
        `${fmtMsg(LowBandWidthLocales.RemoteStudentLowBandwidthDescPrefix)} `,
        h("strong", studentName),
        ` ${fmtMsg(LowBandWidthLocales.RemoteStudentLowBandwidthDescSuffix)}`,
      ]),
    ]),
    duration: SHOW_LOW_BANDWIDTH_NOTIFICATION_DURATION,
  });
};
